const REACTIONS = {
  love: {
    emoji: '❤️',
  },
  celebrate: {
    emoji: '🎉',
  },
  fire: {
    emoji: '🔥',
  },
  idea: {
    emoji: '💡',
  },
  laughing: {
    emoji: '😂',
  },
} as const;

type Sentiment = keyof typeof REACTIONS;

const EMOJI_REACTION = Object.entries(REACTIONS).reduce((acc, [key, val]) => {
  acc[val.emoji] = key as Sentiment;
  return acc;
}, {} as Record<string, Sentiment>);

export { REACTIONS, EMOJI_REACTION };
export type { Sentiment };
